import { Box, Heading, Text } from '@chakra-ui/react';
import {
  selectCurrentUserEmail,
  selectCurrentUserId,
  selectCurrentUserSubscriptionPlan,
  useAuthStore,
} from '@waitroom/auth';
import { selectCurrentSessionId, useSessionStore } from '@waitroom/common';
import { ReactElement, useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SessionSurvey from '../../../../session/components/Form/SessionSurvey/SessionSurvey';
import { TYPEFORM_IN_MEETING_ID, TYPEFORM_MEETING_ENDED_ID } from '../../../../typeform/config';
import { FeedbackModalTypes } from '../../App/Modals/types';
import Modal, { ModalProps } from '../Modal';

export interface FeedbackModalProps extends ModalProps {
  type?: FeedbackModalTypes;
}

const FeedbackModal = (props: FeedbackModalProps): ReactElement | null => {
  const { t } = useTranslation();
  const [isCompleted, setIsCompleted] = useState(false);
  const { onClose, type = FeedbackModalTypes.IN_MEETING } = props;
  const options = useMemo(
    () => ({
      onSubmit: () => setIsCompleted(true),
    }),
    [],
  );
  const user_id = useAuthStore(selectCurrentUserId) ?? 'unknown';
  const user_email = useAuthStore(selectCurrentUserEmail) ?? 'unknown';
  const meeting_id = useSessionStore(selectCurrentSessionId) ?? 'unknown';

  const { status: plan_status } = useAuthStore(selectCurrentUserSubscriptionPlan) ?? {
    status: 'unknown',
  };

  const feedbackGroup =
    type === FeedbackModalTypes.IN_MEETING ? 'inMeetingFeedback' : 'postMeetingFeedback';
  const formId =
    type === FeedbackModalTypes.IN_MEETING ? TYPEFORM_IN_MEETING_ID : TYPEFORM_MEETING_ENDED_ID;

  return (
    <Modal
      size={{ base: 'md', md: 'lg', lg: '2xl' }}
      isCentered
      closeOnOverlayClick={false}
      {...props}
      onClose={() => {
        setIsCompleted(false);
        onClose?.();
      }}
    >
      <Modal.Header />
      <Modal.Body>
        <div>
          {isCompleted ? (
            <Box textAlign="center">
              <Heading as="h1" fontSize="4xl" mb={4}>
                {t(feedbackGroup + '.thankYou')}
              </Heading>
              <Text fontSize="xl">{t(feedbackGroup + '.thankYouDescription')}</Text>
            </Box>
          ) : (
            <div>
              <Box mb={2}>
                <Heading as="h1" fontSize="4xl" mb={4}>
                  {t(feedbackGroup + '.heading')}
                </Heading>
                <Text fontSize="xl">
                  <Trans i18nKey={feedbackGroup + '.description'} />
                </Text>
              </Box>
              <SessionSurvey
                id={formId}
                formProps={options}
                hiddenSurveyProps={{
                  user_email,
                  meeting_id,
                  user_id,
                  plan_status,
                }}
                h="450px"
                w="100%"
              />
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default FeedbackModal;
